import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Carousel from 'react-bootstrap/Carousel';
import { Row, Col, Image } from 'react-bootstrap'; 
import { UserIcon, HomeIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import '../styles/roomCard.css'

const RoomCard = ({ gemImage, title, description, capacity, bed, images, price, facilities, color, onClick }) => {

const { t } = useTranslation();

  const CarouselImages = () => {
    return (
      <Carousel controls={false} indicators={false}>
        {images?.map((image, index) => 
          <Carousel.Item key={index}>
            <Card.Img className="mobileCarouselImage" variant="top" src={image.src} style={{height: '18rem'}} alt="RoomCardCarouselImage"/>
          </Carousel.Item>
        )}
      </Carousel>
    )
  }

  return (
    <Card 
      className="shadow-sm md mt-4" 
      style={{ width: '25rem', cursor: 'pointer', overflow: 'hidden' }}
      onClick={onClick}
    >
      <CarouselImages/>
      
      <Card.Body className="mobileCardBody">
          <Card.Title className="d-flex">
            <Image className="roomGemImage" src={gemImage} style={{marginTop: '0.15rem'}} alt={title + "-gem-image"}/>
            <h4 style={{fontWeight: 'bold'}}>{title}</h4>
          </Card.Title>

          <Card.Text>{description}</Card.Text>
          
          <Row>
            <Col xs={1} lg={1}>
              <UserIcon style={{height: '1rem', color: '#595959', marginTop: '-0.1rem'}} alt="RoomCardDetailsUserIcon"/>
            </Col>

            <Col className="col-auto">
              <Card.Text style={{color: '#595959', fontWeight: '400'}}>{capacity} Guests</Card.Text>
            </Col>
          </Row>

          <Row>
            <Col xs={1} lg={1}>
              <HomeIcon style={{height: '1rem', color: '#595959', marginTop: '-0.2rem'}} alt="RoomCardDetailsFacilitiesHomeIcon"/>
            </Col>

            <Col className="col-auto">
              <Card.Text style={{color: '#595959', fontWeight: '400'}}>{bed}</Card.Text>
            </Col>
          </Row>
          
          <Row className="d-flex justify-content-between align-item-center pt-4">
            <Col className="col-auto">
              <Button className="bookNowButton" style={{padding: '.35rem 2rem', "--color": `${color}`}}>{t('BOOKNOW')}</Button>
            </Col>

            <Col className="col-auto">
              <Card.Text variant="primary" style={{float: 'right', fontWeight: '400', marginTop: '.4rem'}}>{price}</Card.Text>
            </Col>
          </Row>
        </Card.Body>

        <div className="mobileCardBg" style={{"--color": color}}></div>
    </Card>
  )
}

export default RoomCard